import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import { AppBar, Button, Divider, Grid, Toolbar } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import useWidth from '../../components/Hooks/useWidth';
import LangEnum from '../../lang/LangEnum';
import { getAuthLoginPath, getAuthStoreSignUpPath } from '../../routes/auth.routes';
import useTeceoStyles from '../../useTeceoStyles';
import { useTranslation } from '../translation/TranslationContext';

const MyNetworkPublicHeader = () => {
  const { translate } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const { mobileWidth } = useWidth();
  const { classes: teceoClasses } = useTeceoStyles();

  const handleRedirectToLogin = () => {
    history.push(getAuthLoginPath(undefined, search));
  };

  const handleRedirectToRegisterStore = () => {
    history.push(getAuthStoreSignUpPath(undefined, search));
  };

  return (
    <AppBar elevation={0} color="inherit" position="fixed">
      <Toolbar>
        <Grid
          spacing={1}
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          size="grow"
        >
          <Grid
            className={teceoClasses.svgIcon}
            size={{
              xs: 3,
              sm: 2,
              lg: 1,
            }}
          >
            <TeceoLogo />
          </Grid>
          <Grid>
            <Grid
              container
              spacing={1}
              wrap="nowrap"
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Grid>
                <Button
                  size={mobileWidth ? 'small' : 'medium'}
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={handleRedirectToRegisterStore}
                >
                  {translate(LangEnum.LOGIN_REGISTER_MY_STORE)}
                </Button>
              </Grid>
              <Grid>
                <Button
                  size={mobileWidth ? 'small' : 'medium'}
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleRedirectToLogin}
                >
                  {translate(LangEnum.LOGIN_LOGIN)}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};
export default MyNetworkPublicHeader;
